import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseModel } from '@ngx-resource-toolkit/core';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from '../../core/settings/settings.service';
import { EleveRechercheModel } from '../../eleve/models/eleve-recherche.model';
import { EleveModel } from '../../eleve/models/eleve.model';

@Injectable()
export class EleveService {

  constructor(private settings: SettingsService, private http: HttpClient) { }


  searchEleve(searchForm: FormGroup, searchModel: EleveRechercheModel): Observable<any> {
    if (searchForm.controls['id'].value) {
        return searchModel.getResource('default', 'get')
        .call(this.http, 'findById', [searchForm.controls['id'].value, this.settings.getUserSetting('anneeScolaire')])
        .map((data) => {
            const list = [new EleveModel(data)];

            return list;
        });

    } else {
        return searchModel.getResource('default', 'find')
        .call(this.http, searchForm, [])
        .map((data) => {
            let list = [];

            if (data instanceof Array) {
                data.forEach((student) => {
                    list.push(new EleveModel(student));
                });
            }

            return list;
        });
    }
  }


}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/services/eleve.service.ts